import post_29_04_2024 from "../assets/images/posts/post_29_04_2024.jpg";
import post_30_05_2024 from "../assets/images/posts/post_30_05_2024.jpeg";
import post_21_05_2024_2 from "../assets/images/posts/post_21_05_2024_2.png";
import post_21_05_2024_1 from "../assets/images/posts/post_21_05_2024_1.png";
import post_12_05_2024 from "../assets/images/posts/post_12_05_2024.png";
import post_09_05_2024 from "../assets/images/posts/post_09_05_2024.jpeg";
import post_01_05_2024 from "../assets/images/posts/post_01_05_2024.png";
import post_07_06_2024 from "../assets/images/posts/post_07_06_2024.jpeg";
import post_06_06_2024 from "../assets/images/posts/post_06_06_2024.png";
import post_22_10_2024 from "../assets/images/posts/post_22_10_2024.png";
import post_19_11_2024 from "../assets/images/posts/post_19_11_2024.jpeg";
import post_24_02_2025 from "../assets/images/posts/post_24_02_2025.jpg";
import post_26_02_2025_1 from "../assets/images/posts/post_26_02_2025_1.jpg";
import post_26_02_2025_2 from "../assets/images/posts/post_26_02_2025_2.jpg";
import post_22_04_2025 from "../assets/images/posts/post_22_04_2025.jpg";
import post_24_04_2025 from "../assets/images/posts/post_24_04_2025.jpg";
import post_13_06_2025 from "../assets/images/posts/post_13_06_2025.png";
import post_15_06_2025_1 from "../assets/images/posts/post_15_06_2025_1.jpeg";
import post_15_06_2025_2 from "../assets/images/posts/post_15_06_2025_2.jpg";
import post_31_10_2025_1 from "../assets/images/posts/post_31_10_2025_1.jpeg";
import post_20_12_2025_2 from "../assets/images/posts/post_20_12_2025_2.jpeg";
import post_23_12_2025_1 from "../assets/images/posts/post_23_12_2025_1.png";
import post_19_01_2026_1 from "../assets/images/posts/post_19_01_2026_1.png";
import post_23_01_2026_1 from "../assets/images/posts/post_23_01_2026_1.png";
import post_12_03_2026_1 from "../assets/images/posts/post_12_03_2026_1.png";
import post_30_03_2026_1 from "../assets/images/posts/post_30_03_2026_1.png";
import post_31_03_2026_1 from "../assets/images/posts/post_31_03_2026_1.png";
import post_31_03_2026_2 from "../assets/images/posts/post_31_03_2026_2.png";
import post_27_04_2026_3 from "../assets/images/posts/post_27_04_2026_3.png";
import post_04_05_2026 from "../assets/images/posts/post_04_05_2026.jpg";
import post_10_05_2026 from "../assets/images/posts/post_10_05_2026.png";
import post_01_05_2026 from "../assets/images/posts/post_01_05_2026.jpg";
import post_13_05_2026 from "../assets/images/posts/post_13_05_2026.png";
import post_audiencia_2026 from "../assets/images/posts/post_audiencia_2026.png";
import post_29_05_2026 from "../assets/images/posts/post_29_05_2026.png";
import post_29_05_2026_servidor from "../assets/images/posts/post_29_05_2026_servidor.jpg";
import post_29_05_2026_convocatoria_03 from "../assets/images/posts/post_29_05_2026_convocatoria_03.jpg";
import post_05_06_2026_dia_de_la_bandera from "../assets/images/posts/post_05_06_2026_dia_de_la_bandera.png";
import post_05_06_2026_dia_de_la_bandera_2 from "../assets/images/posts/post_05_06_2026_dia_de_la_bandera_2.jpg";
import post_01 from "../assets/images/posts/post_1.jpeg";
import post_02 from "../assets/images/posts/post_2.jpeg";
import post_03 from "../assets/images/posts/post_3.jpeg";
import post_04 from "../assets/images/posts/post_4.jpeg";
import post_05 from "../assets/images/posts/post_5.jpeg";
import post_06 from "../assets/images/posts/post_6.jpeg";
import post_07 from "../assets/images/posts/post_7.jpeg";
import post_08 from "../assets/images/posts/post_8.jpeg";
import post_09 from "../assets/images/posts/post_9.jpeg";
import post_21_06_2026 from "../assets/images/posts/post_21_06_2026.png";
import post_06_07_2026_DIA_DEL_MAESTRO from "../assets/images/posts/post_06_07_2026_DIA_DEL_MAESTRO.png";
import post_28_07_2026_FIESTAS_PATRIAS from "../assets/images/posts/post_28_07_2026_FIESTAS_PATRIAS.jpg";
import post_30_07_2026_pesame_omar from "../assets/images/posts/post_30_07_2026_pesame_omar.jpg";
import post_13_08_2026_condolencias from "../assets/images/posts/post_13_08_2026_condolencias.jpg";
import post_04_09_2026_convocatoria_04 from "../assets/images/posts/post_04_09_2026_convocatoria_04.jpg";
import post_22_09_2026_acta from "../assets/images/posts/post_22_09_2026_acta.png";
import post_23_09_2026_acta_curricular from "../assets/images/posts/post_23_09_2026_acta_curricular.png";
import post_24_09_2026_acta_final from "../assets/images/posts/post_24_09_2026_acta_final.png";
import post_10_10_2026_beca_18 from "../assets/images/posts/post_10_10_2026_beca_18.jpg";
import post_video_pension65 from "../assets/images/posts/post_video_pension65.jpg";
import post_20_10_2026_llamkasun from "../assets/images/posts/post_20_10_2026_llamkasun.png";
import post_21_10_2026_rendicion_cuentas from "../assets/images/posts/post_21_10_2026_rendicion_cuentas.png";

export const postsList = [
    {
        message: "CONSTANCIA DE PRESENTACIÓN DEL INFORME DE RENDICIÓN DE CUENTAS DE TITULARES INICIAL\n\nLa Contraloría General de la República del Perú hace constar la presentación virtual del Informe de Rendición de Cuentas de Titulares POR CESE EN EL CARGO que comprende información entre el 01/01/2026 y el 30/09/2026 de la entidad: MUNICIPALIDAD DISTRITAL DE LA LIBERTAD DE PALLAN, cuyo titular es MANUEL FABIAN BALLEJOS MEJIA, en el cargo de ALCALDE.\n\nAcceda al informe completo a través del siguiente enlace.",
        full_picture: post_21_10_2026_rendicion_cuentas,
        created_time: "2026-10-21",
        permalink_url: "/municipalidad/instrumentos-de-gestion/rendicion-de-cuentas-y-transferencia-de-gestion-2023-2026",
        btn_label: "Ver informe",
        type: "Article",
        target: "_self",
    },
    {
        message: "¡TU MUNICIPALIDAD TE INVITA A PARTICIPAR EN EL PROGRAMA LLAMKASUN PERÚ! 👷‍♂️🇵🇪\n\nEl Programa Llamkasun Perú y la Municipalidad Distrital de La Libertad de Pallán te ofrecen la oportunidad de contar con un empleo temporal y recibir un incentivo económico, contribuyendo activamente a la mejora de nuestro distrito y centros poblados.\n\n📢 ¡INFORMACIÓN IMPORTANTE!\nLa actividad de intervención inmediata está situada en las localidades de PAUCAPAMPA y NUEVO HORIZONTE, y cuenta con 62 EMPLEOS TEMPORALES DISPONIBLES.\n\n👥 REQUISITOS:\n• Tener entre 18 y 70 años de edad.\n• Estar en situación de desempleo o subempleo.\n\n💰 BENEFICIOS:\n• Incentivo económico de S/ 50 por día de participación (S/ 1,600 por 32 días trabajados).\n• Póliza de seguro.\n• Kit de implementos de seguridad y sanitario.\n\n📍 ¡LA INSCRIPCIÓN ES COMPLETAMENTE GRATUITA!\nPara mayor información e inscripciones, acércate a la Municipalidad Distrital de La Libertad de Pallán o comunícate a los teléfonos:\n📞 945 120 919\n📞 916 012 149\n\n🗓️ Fechas de inscripción: Desde el 20 hasta el 26 de Octubre.\n¡Trabaja hoy por un mejor mañana! ¡No dejes pasar esta oportunidad!",
        full_picture: post_20_10_2026_llamkasun,
        created_time: "2026-10-20",
        btn_label: "Descargar afiche",
        type: "Share",
    },
    {
        message: "🛡️ ¡CUIDADO! EVITEMOS LAS ESTAFAS A NUESTROS ADULTOS MAYORES - PENSIÓN 65\n\n⚠️ AVISO IMPORTANTE:\nLos promotores oficiales de Pensión 65:\n✅ NO ofrecen bonos\n✅ NO piden su tarjeta de débito\n✅ NO solicitan su clave secreta\n\nEl equipo institucional recorre debidamente identificado con fotocheck visible y chaleco oficial.\n\n🚨 ¡ALERTA! Se ha detectado que personas inescrupulosas se hacen pasar por personal de la Municipalidad y de Pensión 65 para solicitar DNI, tarjetas de pensión y claves secretas.\n\n🔹 NUNCA comparta sus datos personales ni claves con nadie.\n🔹 Si tiene dudas, verifique siempre la identidad del personal.",
        full_picture: post_video_pension65,
        created_time: "2026-10-12",
        permalink_url: "https://www.facebook.com/share/r/19zxfwkdRX/",
        btn_label: "Ver video",
        type: "Facebook",
        target: "_blank",
    },
    {
        message: "¡CONCURSO BECA 18 - CONVOCATORIA 2027 DEL PRONABEC!\nSe ofrecen 6,000 becas integrales para estudiar una carrera profesional en universidades e institutos elegibles del Perú.\n\n¿A quiénes está dirigido?\nEstudiantes del último grado de secundaria y egresados que cumplan los requisitos del concurso.\n\nBeneficios:\n• Matrícula y pensiones de estudios\n• Alimentación y alojamiento, según corresponda\n• Movilidad local\n• Materiales de estudio\n• Computadora portátil, según las condiciones aplicables\n• Otros beneficios establecidos en las bases.\n\nInscripción al ENP: Hasta el 16 de octubre de 2026.\nMayor información en: www.formate.pe/becas y pronabec.gob.pe/beca-18",
        full_picture: post_10_10_2026_beca_18,
        created_time: "2026-10-10",
        permalink_url: "https://www.pronabec.gob.pe/beca-18/",
        btn_label: "Más información",
        type: "Article",
        target: "_blank",
    },
    {
        message: "¡ACTA DE ENTREVISTA PERSONAL Y RESULTADOS FINALES - CAS TRANSITORIO N° 004-2026-MDLLP!",
        full_picture: post_24_09_2026_acta_final,
        created_time: "2026-09-24",
        permalink_url: "/convocatoria-cas",
        btn_label: "Ver Acta",
        type: "Article",
        target: "_self",
    },
    {
        message: "¡ACTA DE EVALUACIÓN CURRICULAR - CAS TRANSITORIO N° 004-2026-MDLLP!",
        full_picture: post_23_09_2026_acta_curricular,
        created_time: "2026-09-23",
        permalink_url: "/convocatoria-cas",
        btn_label: "Ver Acta",
        type: "Article",
        target: "_self",
    },
    {
        message: "¡ACTA DE POSTERGACIÓN DE EVALUACIÓN CURRICULAR N.° 001-2026 - CAS TRANSITORIO N° 004-2026-MDLLP!",
        full_picture: post_22_09_2026_acta,
        created_time: "2026-09-22",
        permalink_url: "/convocatoria-cas",
        btn_label: "Ver Acta",
        type: "Article",
        target: "_self",
    },
    {
        message: "¡NUEVAS OPORTUNIDADES LABORALES - CONVOCATORIA CAS TRANSITORIO N° 004-2026-MDLLP! Se requiere Sub Gerente de Logística y Control Patrimonial. Plazo para postular: 18 de septiembre de 2026 (08:00 - 17:30).",
        full_picture: post_04_09_2026_convocatoria_04,
        created_time: "2026-09-04",
        permalink_url: "/convocatoria-cas",
        btn_label: "Ver Convocatoria",
        type: "Article",
        target: "_self",
    },
    {
        message: "El Alcalde y el Concejo de la Municipalidad Distrital de La Libertad de Pallán, expresan en este momento de dolor, sus más sentidas condolencias a los familiares de quien en vida fue: JUAN DE LAS ROSAS PEREZ CERDÁN.\nExregidor e integrante de la comisión de la creación del distrito La Libertad de Pallán.\nRogamos para que Dios brinde la Paz y la resignación, necesarias para superar esta irreparable pérdida.",
        full_picture: post_13_08_2026_condolencias,
        created_time: "2026-08-13",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "MUNICIPALIDAD DISTRITAL DE LA LIBERTAD DE PALLÁN EXPRESA SU MÁS PROFUNDO Pésame POR EL SENSIBLE FALLECIMIENTO DEL SEÑOR: Omar Díaz Rabanal.\nNos unimos al dolor que embarga a su familia, amigos, autoridades y a toda la población del distrito de Jorge Chávez, expresando nuestra solidaridad en estos difíciles momentos.\nSu compromiso, vocación de servicio y entrega a su pueblo serán siempre recordados y dejan un legado que perdurará en la memoria de quienes lo conocieron.\nElevamos nuestras oraciones por su eterno descanso y pedimos a Dios que brinde fortaleza y consuelo a sus seres queridos.",
        full_picture: post_30_07_2026_pesame_omar,
        created_time: "2026-07-30",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "¡Felices Fiestas Patrias! Perú 28 y 29 de Julio.\nEn estas Fiestas Patrias renovamos nuestro amor por el Perú y nuestro compromiso de seguir trabajando con unidad, honestidad y vocación de servicio por el desarrollo de nuestro querido distrito.\n¡Que viva el Perú! ¡Que viva La Libertad de Pallán!",
        full_picture: post_28_07_2026_FIESTAS_PATRIAS,
        created_time: "2026-07-28",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "¡Feliz Día del Maestro!\nHoy rendimos homenaje a quienes con vocación, paciencia y entrega transforman vidas y construyen un futuro mejor para nuestra niñez y juventud.\nGracias, maestros, por su dedicación, por inspirar sueños y por formar ciudadanos de bien.\n¡Gracias por enseñar con el corazón!",
        full_picture: post_06_07_2026_DIA_DEL_MAESTRO,
        created_time: "2026-07-06",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "¡Feliz Día del Padre!",
        full_picture: post_21_06_2026,
        created_time: "2026-06-21",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "¡FELIZ DÍA DE LA BANDERA!\nHoy, 7 de junio, la Municipalidad Distrital de La Libertad de Pallán rinde un sincero y ferviente homenaje a nuestro máximo símbolo patrio: la bandera del Perú.\nRecordamos con orgullo la valentía de nuestros héroes en el Morro de Arica y renovamos nuestro compromiso de trabajar con integridad, unión y patriotismo por el desarrollo de nuestro querido distrito. Que los colores rojo y blanco sigan inspirando nuestras acciones diarias para construir un Pallán más justo, próspero y solidario.\n¡Honremos nuestro símbolo patrio con orgullo y civismo!",
        full_picture: [post_05_06_2026_dia_de_la_bandera, post_05_06_2026_dia_de_la_bandera_2, post_01, post_02, post_03, post_04, post_05, post_06, post_08, post_09],
        created_time: "2026-06-05",
        permalink_url: "galeria",
        btn_label: "Ver más",
        type: "Article",
        target: "_self",
    },
    {
        message: "¡NUEVAS OPORTUNIDADES LABORALES - CONVOCATORIA CAS TRANSITORIO N° 003-2026-MDP! Se requiere Jefe de la Oficina de Defensa Civil y Sub Gerente de Logística. Plazo para postular: 15 de junio de 2026 (08:00 - 17:30).",
        full_picture: post_29_05_2026_convocatoria_03,
        created_time: "2026-05-30",
        permalink_url: "/convocatoria-cas",
        btn_label: "Ver Convocatoria",
        type: "Article",
        target: "_self",
    },
    {
        message: "¡Feliz Día del Servidor Público! Desde la Municipalidad Distrital de La Libertad de Pallán queremos reconocer y felicitar a todas las servidoras y servidores públicos que, con compromiso, vocación y profesionalismo, contribuyen cada día al fortalecimiento de nuestra institución y a la mejora de los servicios que recibe la ciudadanía. ¡Feliz 29 de mayo!",
        full_picture: post_29_05_2026_servidor,
        created_time: "2026-05-29",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "¡PARTICIPA DEL SIMULACRO NACIONAL MULTIPELIGRO! Este viernes 29 de mayo a las 10:00 a.m. ante sismo y peligros asociados. ¡Elige prepararte!",
        full_picture: post_29_05_2026,
        permalink_url: "https://www.gob.pe/institucion/indeci/campa%C3%B1as/140975-simulacro-nacional-multipeligro-elige-prepararte",
        created_time: "2026-05-29",
        btn_label: "Ver más",
        type: "Article",
    },
        {
        message: "AUDIENCIA PÚBLICA PARA RENDICIÓN DE CUENTAS PARA EL AÑO FISCAL 2026",
        full_picture: post_audiencia_2026,
        created_time: "2026-05-21",
        permalink_url: "/servicios/transparencia/audiencia-publica-rendicion-de-cuentas-2026",
        btn_label: "Ver más",
        type: "Article",
        target: "_self"
    },
    
    {
        message: "¡ACTA DE EVALUACIÓN CURRICULAR - CAS TRANSITORIO N° 002-2026-MDLLP!",
        full_picture: post_13_05_2026,
        created_time: "2026-05-13",
        permalink_url: "/convocatoria-cas",
        btn_label: "Ver Convocatoria",
        type: "Article",
        target: "_self"
    },
    {
        message: "¡Feliz Día de la Madre!",
        full_picture: post_10_05_2026,
        created_time: "2026-05-10",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "NUEVAS OPORTUNIDADES LABORALES - CONVOCATORIA CAS TRANSITORIO N° 002-2026-MDP. Jefe de Defensa Civil y Sub Gerente de Logística.",
        full_picture: post_04_05_2026,
        created_time: "2026-05-02",
        permalink_url: "/convocatoria-cas",
        btn_label: "Ver Convocatoria",
        type: "Article",
        target: "_self"
    },
    {
        message: "¡Feliz Día del Trabajo! - La Municipalidad Distrital de Pallán rinde homenaje a todos los trabajadores que con su esfuerzo diario contribuyen al progreso de nuestro distrito. ¡Feliz 1 de Mayo!",
        full_picture: post_01_05_2026,
        created_time: "2026-05-01",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "CONVOCATORIA PROCESO DE SELECCIÓN CAS TRANSITORIO N° 002-2026-MDLLP",
        full_picture: post_27_04_2026_3,
        created_time: "2026-04-27",
        permalink_url: "https://drive.google.com/drive/folders/1PGrBxGKCZ7nxlrl8oJV9_HyBXU-umhl0?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "¡ACTA DE DECLARATORIA DE DESIERTO - CAS TRANSITORIO Nº 001-2026 MDLLP!",
        full_picture: post_31_03_2026_2,
        created_time: "2026-03-31",
        permalink_url: "https://drive.google.com/file/d/11KhFm9nkDeTQ_Rk9qTOlbrqDHx-_DTZr/view?usp=drive_link",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "¡ACTA DE EVALUACION ENTREVISTA PERSONAL RESULTADO FINAL - CAS TRANSITORIO Nº 001-2026 MDLLP!",
        full_picture: post_31_03_2026_1,
        created_time: "2026-03-31",
        permalink_url: "https://drive.google.com/file/d/1-S3Ck7ENfFGkz44n5vBwAt63klScl-ny/view?usp=drive_link",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "¡ACTA DE EVALUACION CURRICULAR - CAS TRANSITORIO Nº 001-2026 MDLLP!",
        full_picture: post_30_03_2026_1,
        created_time: "2026-03-30",
        permalink_url: "https://drive.google.com/file/d/1YStRx0CWAy8LzBUAE7cEnf2eDe8AM4O-/view?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "¡CONVOCATORIA PARA LA CONTRATACIÓN ADMINISTRATIVA DE SERVICIOS EN LA MUNICIPALIDAD DISTRITAL LA LIBERTAD DE PALLAN!",
        full_picture: post_12_03_2026_1,
        created_time: "2026-03-12",
        permalink_url: "https://drive.google.com/drive/folders/1CUODjpTj2z96IMd7KVp9-I_MSRVzHj4m",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "¡Potencia tu Futuro con Jóvenes Productivos!",
        full_picture: post_23_01_2026_1,
        created_time: "2026-01-23",
        permalink_url: "https://drive.google.com/drive/folders/1lbiF5weGYAcDmyEhiDCIm_wAdPuYBFSz?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "CUADO MULTIANUAL DE NECESIDADES 2026",
        full_picture: post_19_01_2026_1,
        created_time: "2026-01-19",
        permalink_url: "https://drive.google.com/file/d/13YdkJJjD7fy_hhSPAmBt2fyuGfz235mc/view?usp=drive_link",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "POR EL 32 ANIVERSARIO DE CREACION POLITICA DEL DISTRITO DE LA LIBERTAD DE PALLAN",
        full_picture: post_23_12_2025_1,
        created_time: "2025-12-29",
        permalink_url: "https://drive.google.com/drive/folders/1C7Z9PhEsKaWiZx7e6lowyTP-vbYdy8t4?usp=drive_link",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "ACTUALIZA TU CLASIFICACION SOCIOECONOMICA",
        full_picture: post_20_12_2025_2,
        created_time: "2025-12-15",
        permalink_url: "https://drive.google.com/drive/folders/1qUT47xwJvhaaYTK1z-hZ1jxByEJVPE__?usp=drive_link",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "COMUNICADO",
        full_picture: post_31_10_2025_1,
        created_time: "2025-10-31",
        permalink_url: "https://drive.google.com/drive/folders/1zDWBALCPtCx-ftVa0pSsCvbOh5ptGCr0?usp=drive_link",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Programa - Fiesta Patronal San Juan Bautista 2025",
        full_picture: post_15_06_2025_2,
        created_time: "2025-06-15",
        permalink_url: "https://drive.google.com/drive/folders/1R88pumTZxHbv2gY49PDqohGADpz4WGSq?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Únete a los Censos Nacionales 2025 - Convocatoria a nivel nacional",
        full_picture: post_15_06_2025_1,
        created_time: "2025-06-15",
        permalink_url: "https://drive.google.com/drive/folders/1pU99ihMjKX2uD9uTma928r3hMS3QI5GL?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Invitación a la Corrida de Toros en La Libertad de Pallán, del 24 al 26 de Junio",
        full_picture: post_13_06_2025,
        created_time: "2025-06-13",
        permalink_url: "https://www.youtube.com/watch?v=Su5Kr9wMGds",
        btn_label: "Ver video",
        type: "Video",
    },
    {
        message: "DECRETO DE ALCALDIA N.° 001-2025-MDLLP/A.",
        created_time: "2025-04-30",
        permalink_url: "https://drive.google.com/file/d/1758qTIp9j0CScOiXmhHqEiSVpyNHsvTC/view?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Acta de evaluación entrevista personal de los postulantes del concurso CAS N°002-2025-MDLLP.",
        full_picture: post_24_04_2025,
        created_time: "2025-04-24",
        permalink_url: "https://drive.google.com/file/d/1f_tHW2Czs11wtv8P_wmdfSmaI9eCpjym/view?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Acta de evaluación curricular de los postulantes del concurso CAS N°002-2025-MDLLP.",
        full_picture: post_22_04_2025,
        created_time: "2025-04-22",
        permalink_url: "https://drive.google.com/file/d/1lkZNgycItA6y69UiSnGS_Q4dfLdJxomj/view?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Convocatoria para la contratación administrativa de servicios por necesidad transitoria de dos (02) profesionales.",
        created_time: "2025-03-31",
        permalink_url: "https://drive.google.com/drive/folders/194rR2EALYbK7qkBjMMQqIJcUkEroVy6f?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "ACTA DE EVALUACION ENTREVISTA PERSONAL DE LA CONVOCATORIA CAS 001 - 2025 - MDLLP",
        full_picture: post_26_02_2025_2,
        created_time: "2025-02-26",
        permalink_url: "https://drive.google.com/drive/folders/1IK82qODh_Kkepvl-lkFbZhjgWTIfT9xI?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "ACTA DE DECLARATORIA DESIERTO DE LA CONVOCATORIA CAS 001 - 2025 - MDLLP",
        full_picture: post_26_02_2025_1,
        created_time: "2025-02-26",
        permalink_url: "https://drive.google.com/file/d/1S30hKPSi1lPTBptSYrNLNNvUmfE6-lVv/view?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "RESULTADOS EVALUACION CURRICULAR DE LA CONVOCATORIA CAS 001 - 2025 - MDLLP",
        full_picture: post_24_02_2025,
        created_time: "2025-02-24",
        permalink_url: "https://drive.google.com/drive/folders/1OhT7ENcVXzIlHomJRP6zFTzHl7B7Iqh7?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Convocatoria para la contratación administrativa de servicios por necesidad transitoria de cinco (05) profesionales.",
        created_time: "2025-02-05",
        permalink_url: "https://drive.google.com/drive/folders/1o0ZitTQQYAZVH_RC3LWAA2QAk1tsO55i?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Convocatoria para Yachachiq en La Libertad de Pallan, Cajamarca. Postulaciones del 18 al 29 de noviembre vía FONCODES.",
        full_picture: post_19_11_2024,
        created_time: "2024-11-19",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "Lamentamos el sensible fallecimiento de Guitler Ronal Mendoza Micha, acompañamos a su familia en este difícil momento y pedimos a Dios que les de fortaleza y resignación.",
        full_picture: post_22_10_2024,
        created_time: "2024-10-22",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "Entrega de alimentos del convenio entre la Municipalidad de La Libertad de Pallán y el Programa Qali Warma a instituciones educativas de nuestro distrito.",
        full_picture: "https://drive.google.com/thumbnail?id=19-Ob93pvfcPXchbDVqYXWQF29AZu-ldN&sz=w1000",
        created_time: "2024-10-22",
        permalink_url: "https://drive.google.com/drive/folders/1LxpGsFTeSCloGnNv36QFE8QTfdvR0V8G?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Firma de convenio entre la Municipalidad de La Libertad de Pallán y de Huasmín.",
        full_picture: "https://drive.google.com/thumbnail?id=1oUBfagRz3j1c3Aq6DMm4RMJPaeEyRUsE&sz=w1000",
        created_time: "2024-10-21",
        permalink_url: "https://drive.google.com/drive/folders/1J_Yg6ChHmAZX3Lb6rQKaIAZEeSseWN2I?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Convocatoria para la Contratación Administrativa de Servicios - CAS del sector público de la Municipalidad Distrital de la Libertad de Pallán.",
        created_time: "2024-08-14",
        permalink_url: "https://drive.google.com/drive/folders/1PZnEcClLkGBVMbJ85OaOXYy3oJFql2Ct?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Construcción de 2 aulas para el nivel inicial en la comunidad Unión del Norte.",
        full_picture: "https://drive.google.com/thumbnail?id=1X2OsxzPaEgLZ7nD3qLG2A1zvM2PMZyO7&sz=w1000",
        created_time: "2024-07-11",
        permalink_url: "https://drive.google.com/drive/folders/1V9SWLWBY_K2cOuee-MoDYtavbhKL3VMG?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Marcha por el Día Nacional de la Bandera, en nuestro distrito de La Libertad de Pallán.",
        full_picture: post_07_06_2024,
        created_time: "2024-06-07",
        permalink_url: "https://drive.google.com/drive/folders/16gH6VTQAiwF_004EZkkeSag7eOK9VUR4?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Programa para la Fiesta de San Juan Bautista en La Libertad de Pallán en el año 2024.",
        full_picture: "https://www.munilalibertaddepallan.gob.pe/static/media/photo-5.4d8979674f0f61665cf0.jpg",
        created_time: "2024-06-06",
        permalink_url: "https://drive.google.com/file/d/1Gm-zeEgs0NGhP979zlzooqJEXqgkKcsV/view?usp=drive_link",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Invitación a la competencia de Reinas de Belleza de La Libertad de Pallán, el miércoles 19 de junio.",
        full_picture: post_06_06_2024,
        created_time: "2024-06-06",
        permalink_url: "https://www.youtube.com/watch?v=8u0eb1vZi0k",
        btn_label: "Ver video",
        type: "Video",
    },
    {
        message: "Entrega de alimentos por parte de la municipalidad a instituciones educativas en los caseríos de Nuevo Horizonte y Paucapampa",
        full_picture: post_30_05_2024,
        created_time: "2024-05-30",
        permalink_url: "https://drive.google.com/drive/folders/1dykCzeXe1mV3PxTxivG7c6OWdrfVhgTX?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "Visita del congresista Américo Gonza a nuestro distrito y su reunión con nuestras autoridades locales.",
        full_picture: post_21_05_2024_1,
        created_time: "2024-05-21",
        permalink_url: "https://www.facebook.com/share/v/Y6qx8xBsLM2LU59J/?mibextid=CmRSLE",
    },
    {
        message: "Visita del congresista Américo Gonza al centro poblado de Callacat Bajo en el distrito de La Libertad de Pallán.",
        full_picture: post_21_05_2024_2,
        created_time: "2024-05-21",
        permalink_url: "https://www.facebook.com/share/v/YysSQvLPNemTVion/?mibextid=U8WOFx",
    },
    {
        message: "¡Feliz Día de la Madre! - A todas las madres de nuestro distrito, gracias por su amor y dedicación.",
        full_picture: post_12_05_2024,
        created_time: "2024-05-12",
        permalink_url: "https://www.youtube.com/watch?v=Qd3AAV8HZSc",
        btn_label: "Ver video",
        type: "Video",
    },
    {
        message: "Firma de convenio entre la Municipalidad de Celendín y la Municipalidad de La Libertad de Pallán.",
        full_picture: post_09_05_2024,
        created_time: "2024-05-09",
        permalink_url: "https://drive.google.com/drive/folders/1ondO4SFarbeTTtx6AoMjalrgeoNM6pSS?usp=sharing",
        btn_label: "Ver más",
        type: "Article",
    },
    {
        message: "¡Feliz Día del Trabajo! - ¡Gracias a todos los trabajadores por su incansable y noble labor!",
        full_picture: post_01_05_2024,
        created_time: "2024-05-01",
        btn_label: "Compartir",
        type: "Share",
    },
    {
        message: "Presupuesto Participativo 2025 - Inscríbete en nuestra mesa de partes virtual y participa.",
        full_picture: post_29_04_2024,
        created_time: "2024-04-29",
        permalink_url: "https://www.youtube.com/watch?v=4WOmTcEbX58",
        btn_label: "Ver video",
        type: "Video",
    },
    {
        message: "Transferencia de partidas a favor de gobiernos locales para la ejecución de proyectos de inversión pública.",
        created_time: "2024-04-29",
        permalink_url: "/municipalidad/instrumentos-de-gestion/transferencia-de-partidas",
        btn_label: "Ver más",
        target: "_self",
        type: "Article",
    },
];
